import { Box, BoxProps } from '@mui/material'
import React, { FunctionComponent } from 'react'

export const Span: FunctionComponent<BoxProps> = (props) => <Box component={'span'} {...props}></Box>